(function () {
    'use strict';

    angular.module('dashboardModule')
        .config(['$stateProvider', '$urlRouterProvider', routesConfig]);

    function routesConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('reading-list', {
                url: '/reading-list',
                templateUrl: 'app/dashboard/reading-list/reading-list-view.html',
                controller: 'reading-list-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Reading list',
                    description: 'Reading list'
                }
            })
            .state('reading-list-detail', {
                url: '/reading-list/:readingListId',
                params: { readingListId: null },
                templateUrl: 'app/dashboard/reading-list/reading-list-view.html',
                controller: 'reading-list-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Reading list',
                    description: 'Reading list'
                }
            });
        $urlRouterProvider.otherwise('/');
    };
})();